import React from 'react';
import { Input } from 'semantic-ui-react';
import get from 'lodash.get';
import FormbuilderFieldWrapper from '../../../../formBuilderAnswersComponents/formbuilderFieldWrapper';

interface TextFieldProps {
  label?: string;
  value?: number | string;
  update: (value: string) => void;
  fieldName: string;
  validation?: unknown;
  autoFocus?: boolean;
  systemOnly?: boolean;
}

class TextField extends React.Component<TextFieldProps> {
  TextFieldInputRef: any = null;

  componentDidMount() {
    if (this.TextFieldInputRef && this.props.autoFocus) {
      const value = get(this.TextFieldInputRef, 'props.value');

      this.TextFieldInputRef.focus();

      if (
        value !== null &&
        value !== undefined &&
        this.TextFieldInputRef.inputRef &&
        Object.isExtensible(this.TextFieldInputRef.inputRef.selectionStart)
      ) {
        this.TextFieldInputRef.inputRef.selectionStart = value.length;
        this.TextFieldInputRef.inputRef.selectionEnd = value.length;
      }
    }
  }

  render() {
    const { label, value, update, fieldName, validation, systemOnly } =
      this.props;

    return (
      <FormbuilderFieldWrapper
        label={label}
        systemOnly={systemOnly}
        validation={validation}
        value={value}
      >
        <Input
          placeholder={value}
          value={value}
          onChange={(event) => update(event.target.value)}
          id={`${fieldName}Id`}
          ref={(input) => {
            this.TextFieldInputRef = input;
          }}
        />
      </FormbuilderFieldWrapper>
    );
  }
}

export default TextField;
